<div class="actions-container">
  <div class="conditions-list">
    <p-table
      [value]="actions"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="['value.ruleActionDesc', 'value.kommentar']"
      [scrollable]="true"
      scrollHeight="400px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="grupo-reglas-column">{{ "WXRL.RULE.GRUPO_REGLAS" | translate }}</th>
          <th id="estado-column">Estado</th>
          <th id="orden-column">Orden</th>
          <th id="descripcion-column">Descripción</th>
          <th id="accion-column">Acción</th>
          <th id="id-prueba-column">Id Prueba</th>
          <th id="perfil-column">Perfil</th>
          <th id="id-texto-column">Id texto</th>
          <th id="texto-libre-column">Texto libre</th>
          <th id="a1-column">A1</th>
          <th id="a2-column">A2</th>
          <th id="comentario-column">Comentario</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-actionControl
        let-rowIndex="rowIndex"
      >
        <tr>
          <td>{{ actionHeader?.ruleActionDesc || '-' }}</td>
          <td>{{ getStateLabel(actionControl.value.ruleState) }}</td>
          <td>{{ actionControl.value.posA }}</td>
          <td>{{ actionControl.value.ruleActionDesc }}</td>
          <td>{{ actionControl.value.actionKrz }}</td>
          <td>{{ actionControl.value.methNr | inherited }}</td>
          <td>{{ actionControl.value.grupNr }}</td>
          <td>{{ actionControl.value.textNr }}</td>
          <td>{{ actionControl.value.actionValue }}</td>
          <td>{{ actionControl.value.additional1 }}</td>
          <td>{{ actionControl.value.additional2 }}</td>
          <td>{{ actionControl.value.kommentar }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="12" style="text-align: center">
            No hay acciones definidas
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
